import { Config } from "./Config";

export const SUCCESS = 0;
export const ERROR = -1;
export const INVALID_CREDENTIALS = -601;
export const ACCOUNT_LOCKED = -602;
export const UNKNOWN_ERROR = -801;
export const UNAUTHORIZED = -109002;
export const SESSION_ID_NULL = -104001;
export const SESSION_ID_DOES_NOT_EXIST = -104002;
export const SESSION_EXPIRED = -104003;
export const PROJECTID_IS_NULL = -105001;
export const PROJECTID_DOES_NOT_EXIST = -105002;
export const USERID_IS_NULL = -101002;
export const USERID_DOES_NOT_EXIST = -101003;
export const WEIGHTAGE_COUNT_DOWN = 300000;
export const CONTRACT_TERM_EXPIRED_ERROR = -107004;
export const CONTRACT_VALUE_EXPIRED_ERROR = -107005;

export const ERROR_MESSAGES_LOGOUT = {
  "-104001":
    "It seems that your session has been manipulated. System is logging you out automattically for security purposes.",
  "-104002":
    "System is unable to match your unique session id. System is logging you out automattically for security purposes.",
  "-104003":
    "Your session has expired due to multiple logins. Please login again to continue.",
  "-101002":
    "System is unable to find your unique user id. System is logging you out automattically for security purposes.",
  "-101003":
    "System is unable to find your unique user id. System is logging you out automattically for security purposes.",
};
export const ERROR_MESSAGES = {
  "-109002":
    "You do not have access to this functionality. Kindly contact the project owner for access.",
  "-105001":
    "System is unable to find the current project. You can use sidebar to navigate to the project again.",
  "-105002":
    "System is unable to find the current project. You can use sidebar to navigate to the project again.",
  "-101002":
    "System is unable to find your unique user id. System is logging you out automattically for security purposes.",
  "-101003":
    "System is unable to find your unique user id. System is logging you out automattically for security purposes.",
};
export const REDIRECT_URLS_COMMON = {};

export const CAPABILITIES_WITH_PROJECTS = [
  1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 14, 18, 19, 20, 21, 22
]; //working capabilities
export const CAPABILITY_STAGES = {
  default: [1, 8, 9, 10, 11, 12],
  1: [1, 3, 8, 9, 10, 11, 12],
  2: [1, 3, 8, 9, 10, 11, 12],
  3: [1, 3, 8, 9, 10, 11, 12],
  5: [1, 8, 9, 10, 11, 12],
  6: [1, 8, 9, 10, 11, 12],
  7: [1, 8, 9, 10, 11, 12],
  8: [1, 8, 9, 10, 11, 12],
  9: [1, 8, 9, 10, 11, 12],
  10: [1, 8, 9, 10, 11, 12],
  11: [1, 8, 9, 10, 11, 12],
  14: [1, 3, 9, 10, 11, 12],
  18: [1, 8, 9, 10, 11, 12],
  19: [1, 8, 9, 10, 11, 12],
  20: [1, 8, 9, 10, 11, 12],
  21: [1, 8, 9, 10, 11, 12],
  22: [1, 8, 9, 10, 11, 12],
};

export const CAPABILITY_NAME = {
  1: "Landscape guided partnership",
  2: "Product Licensing/ Acquisition (dossier/ supply)",
  3: "Partner enabled Manufacturing",
  5: "Out-licensing",
  6: "Solution Scouting",
  7: "Competitive Scan",
  8: "White Spaces",
  9: "Portfolio Gap Assessment",
  10: "Business Models",
  11: "New Area/ Category",
  13: "Formula Checker",
  14: "Idea/Concept Feasibility",
  17: "Ad Hoc",
  18: "Concept Generator",
  19: "Consumer Insights",
  20: "HWS",
  21: "Biological",
  22: "Consumer Need",
};
export const CAPABILITIES_WITH_PROCESSING = [7, 13]; //other capabilities involve human systemization to show msg
export const PRODUCT_NATURES = {
  1: { cName: "fa fa-medkit", title: "Health" },
  2: { cName: "fa fa-heartbeat", title: "Wellness" },
};

export const SESSION_MANIPULATED =
  "It seems that your session has been manipulated. System is logging you out automattically for security purposes.";
export const VAULT_ID_NULL =
  "It seems that your session has been manipulated. System is logging you out automattically for security purposes.";
export const PROJECT_ID_NULL =
  "It seems that data related to the current project has been manipulated. You can visit capability of your interest using side bar.";
export const SINGLE_INSTANCE_MSG =
  "For security purposes, this platform can only be opened in a single browser tab.";
export const UNAUTHORIZED_MSG =
  "You do not have access to this functionality. Kindly contact the project owner for access.";
export const SESSION_EXPIRED_MSG =
  "Your session has expired due to inactivity. Please login to continue.";
export const REQUEST_TIME_OUT_MSG =
  "Your request has timed out. Please try after some time.";
export const SERVER_DOWN_MSG = "Server down. Please try again.";
export const CATCH_ERROR = "It’s us, not you. Please try after some time.";
export const EXPORT_CATCH_ERROR =
  "It’s us, not you. Please try to export again.";
export const IP_CONSENT_CONFIRMATION =
  "The IP mapping process will be terminated. Are you sure to leave the screen?";
export const PARTNER_CONSENT_CONFIRMATION =
  "The partner connect process will be terminated. Are you sure to leave the screen?";
export const SCIENTIFIC_CONFIRMATION =
  "The scientific assessment process will be terminated. Are you sure to leave the screen?";
export const TERM_TOP_UP =
  "Thanks for availing the contract term top-up. Your contract term has been extended and your access has been restored. The price incurred for the top-up shall be charged in the next invoice.";
export const VALUE_TOP_UP =
  "Thanks for availing the contract value top-up. Your contract value has been extended and your access has been restored. The price incurred for the top-up shall be charged in the next invoice.";
export const PARTNER_CONNECT =
  "Well done in selecting relevant players for partnership assessment. We have initiated the intention check process and you will be notified with updates via email as soon as there is a response.";
export const IP_MAPPING =
  "Thanks for sharing the request for the IP assessment. We have initiated the assessment process and you shall be notified via email when the outcome is ready. Turnaround time: 2-5 business days.";
export const SCIENTIFIC_ASSESSMENT =
  "Thanks for sharing the request for the scientific assessment. We have initiated the assessment process and you shall be notified via email when the outcome is ready. Turnaround time: 2-5 business days.";
//time out codes
export const REQUEST_TIME_OUT = 900;
export const SESSION_TIME_OUT = REQUEST_TIME_OUT;
export const REQUEST_TIME_OUT_1 =300;
export const VAULT_REQUEST_TIME_OUT = 120;
export const NO_ACCESS_RIGHT_BU = -111003;

export const LICENSE_TYPES = {
  0: "Both",
  1: "Dossier license",
  2: "Supply license",
};
export const TREE_CONFLICT = "-116007";
export const SAME_ENTRY_CONFLICT = "-116006";
export const INVALID_PREFERENCE_CONFLICT = "-116008";

export const MOBILE_VIEW_NOT_APPLICABLE =
  "This platform can't be assessed on small screens.";
export const REQUEST_TIME_IP_URL = 60;

//GRAPH RELATED
export const CAPABILITY_TAGS_AVAILABLE_IN_GRAPHS = [
  "timely audited facility",
  "manufacturing capability",
  "no warning letters",
  "no efficacy concerns",
  "innovation capability",
];
export const RECOMMENDATION_VALUEMATRIX_FILTERS = [
  { label: "Desired Partners", value: "AD1" },
  { label: "Timely Audited Facility", value: "timely audited facility" },
  { label: "Manufacturing Capability", value: "manufacturing capability" },
  { label: "No Warning Letters", value: "no warning letters" },
  { label: "No Efficacy Concerns", value: "no efficacy concerns" },
  { label: "Innovation Capability", value: "innovation capability" },
];

export const RECOMMENDATION_FILTERS = [
  { label: "Desired Partners", value: "countOfPreferencesSatisfied" },
  {
    label: "Timely Audited Facility",
    value: "hasGmpCertifiedManufacturingSites",
  },
  { label: "Manufacturing Capability", value: "hasManufacturingCapability" },
  { label: "No watch-outs", value: "noWatchOutFilterApplicable" },
  { label: "Innovation capability", value: "hasInnovationCapability" },
];
export const FRESHNESS_VARIANT = [
  { label: "Format", value: "format" },
  { label: "Market", value: "market" },
  { label: "Health benefit", value: "benefit" },
  { label: "Active", value: "active" },
  { label: "Functional benefit", value: "claim" },
];

export const ECOSYSTEM_VARIANT = [
  { label: "Format", value: "formats" },
  { label: "Market", value: "markets" },
  { label: "Health benefit", value: "benefits" },
  { label: "Active", value: "actives" },
  { label: "Functional benefit", value: "claims" },
  { label: "Demography ", value: "userSegment" },
  { label: "Flavor", value: "flavor" },
];

export const FORMAT_VARIANT = [
  { label: "Health benefit", value: "benefit" },
  { label: "Active", value: "active" },
  { label: "Package type", value: "packaging" },
  { label: "Functional benefit", value: "claim" },
  { label: "Market", value: "market" },
  { label: "Flavor", value: "flavor" },
  { label: "Demography ", value: "userSegment" },
];
export const BENEFIT_VARIANT = [
  { label: "Active", value: "active" },
  { label: "Format", value: "format" },
  { label: "Functional benefit", value: "claim" },
  { label: "Market", value: "market" },
  { label: "Demography ", value: "userSegment" },
];

export const DEMO_VARIANT = [
  { label: "Format", value: "formats" },
  { label: "Functional benefit", value: "claims" },
  { label: "Market", value: "markets" },
  { label: "Flavor", value: "flavor" },
];

export const REGULATORY_VARIANT = [
  { label: "Format", value: "format" },
  { label: "Health benefit", value: "benefit" },
  { label: "Active", value: "active" },
  { label: "Functional benefit", value: "claim" },
];

export const POSITIONING_VARIANT = [
  { label: "Format", value: "formats" },
  { label: "Market", value: "markets" },
  { label: "Active", value: "actives" },
  { label: "Demography ", value: "userSegment" },
];

export const OBJECTIVES = {
  c1: "Line Extensions",
  c2: "New Technology Adoption",
  c3: "Market Expansion",
  c4: "Rx to OTC Switch",
  c5: "Include Brand Acquisition Leads",
};

export const PARTNER_CAPABILITY = {
  c1: "GMP certified site",
  c2: "R&D/ innovation capability",
  c3: "Multi-format capability",
  c4: "Experienced player",
  c5: "DTC/ Direct to Consumer Channel",
  c6: "Licensing",
  c7: "Advanced Machinery",
  c8: "API/ Herbs Supply",
  c9: "Private Label Manufacturing",
};
export const PARTNER_QUALITY = {
  c1: "Audited facility",
  c2: "Regulatory compliant formula",
  c3: "No safety/ efficacy concerns",
  t1: "additional details",
};

export const EXPECTATIONS_HEADS = {
  revenueProjections: "Revenue Projections",
  timeToMarket: "Time To Market",
  priceRange: "Price Range",
  objective: "Objective",
  partnerCapacity: "Partner Capacity",
  quality: "Quality",
};

export const GRAPHS_GALLERY = [
  {
    icon: "/images/geo.svg",
    iconSelected: "/images/geo-selected.svg",
    iconName1: "Geographical",
    iconName2: "hot-spots",
    tip: "Market coverage and associated insights.",
  },
  {
    icon: "/images/regul.svg",
    iconSelected: "/images/regul-selected.svg",
    iconName1: "Regulatory",
    iconName2: "Landscape",
    tip: "Distribution and insights as per regulatory classification (across markets).",
  },
  {
    icon: "/images/dosage.svg",
    iconSelected: "/images/dosage-selected.svg",
    iconName1: "Delivery Technology",
    iconName2: "Distribution",
    tip: "Major formats explored and associated insights.",
  },
  {
    icon: "/images/position.svg",
    iconSelected: "/images/position-selected.svg",
    iconName1: "Claim",
    iconName2: "Suitability",
    tip: "Major claims and their utility assessment.",
  },
  {
    icon: "/images/benefit.svg",
    iconSelected: "/images/benefit-selected.svg",
    iconName1: "Health Benefits",
    iconName2: "Mapping",
    tip: "Assessment of health benefits targeted.",
  },
  {
    icon: "/images/demo.svg",
    iconSelected: "/images/demo-selected.svg",
    iconName1: "Demographic",
    iconName2: "Segmentation",
    tip: "Assess and evaluate demographic segmentation-based insights.",
  },
  {
    icon: "/images/fresh.svg",
    iconSelected: "/images/fresh-selected.svg",
    iconName1: "Growth",
    iconName2: "Intensity",
    tip: "Product distribution as per their year of registration/ launch.",
  },
];

export const VARIANTS = [
  { label: "Formats", val: "format" },
  { label: "Health Benefits", val: "benefits" },
  { label: "Active", val: "active" },
  { label: "Functional Benefits", val: "claims" },
  { label: "Flavor", val: "flavor" },
  { label: "Demographics", val: "userSegment" },
  { label: "Markets", val: "markets" },
];
export const HIGH_LEVEL_SUMMARY_FILTERS = {};
export const particularUser = {
  profileImage: "",
  contractId: "",
  userRole: [],
  userAccess: false,
  firstName: "",
  lastName: "",
  gender: 0,
  primaryContact: "",
  secondaryContact: "",
  professionalEmail: "",
  userLocation: "",
  loginId: "",
  organisationFunction: "",
  designation: "",
  organisationalRole: "",
};
export const tabsName = ["Contract Details", "Invoicing", "Users"]; //tab components name

export const INTENT_TO_EXPLORE = {
  1: "Yes",
  2: "No",
  3: "Yes, with some queries",
};
export const projectsComparisonLabels = [
  { index: 1, label: "Project Logo" },
  { index: 2, label: "Project Scope" },
  { index: 3, label: "Fame Index" },
  { index: 4, label: "Complexity Index" },
  { index: 5, label: "Brand Carriers Mapped" },
  { index: 6, label: "Opportunity Mapped" },
  { index: 7, label: "Selected Players" },
  { index: 8, label: "Common Players" },
  { index: 9, label: "Status" },
];

export const capabilityTags = [
  { dbKey: "hasManufacturingCapability", value: "Manufacturing" },
  { dbKey: "hasMarketingCapability", value: "Marketing" },
  { dbKey: "hasInnovationCapability", value: "Innovation" },
  {
    dbKey: "hasContractManufacturingCapability",
    value: "Contract Manufacturing",
  },
  {
    dbKey: "manufacturingSiteHasMultiFormatCapability'",
    value: "Multi-Format Capability",
  },
  { dbKey: "hasMultiRegionReach", value: "Multi-Regional Reach" },
  { dbKey: "noWarningLetters", value: "No Warning Letters" },
  { dbKey: "noEfficacyConcerns", value: "No Efficacy Concerns" },
  { dbKey: "hasExtendedPortfolio", value: "Extended Portfolio" },
  { dbKey: "isExperiencedPlayer", value: "Experienced Player" },
];

export const FAMILIARITY_TYPE = {
  1: "Good Player",
  2: "Bad Player",
  3: "Marked as competitor",
};
export const CAPABILITIES = {
  //for vault
  needHealthCheck: "Landscape guided partnership",
  productLicensing: "Product Licensing/ Acquisition",
  manufacturerProducts: "Partner enabled Manufacturing",
  scouting: "Solution Scouting",
  productLandscape: "Competitive Scan",
  whiteSpace: "White Space",
  portfolioGap: "Portfolio Gap Assessment",
  businessModels: "Business Models",
  newArea: "New Area/ Category Assessment",
  brandExpansion: "Brand Expansion",
  strategic: "Strategic Assessment",
  adHoc: "Ad Hoc",
  conceptGenerator: "Concept Generator",
  ideaConcept: "Idea/Concept Feasibility",
  outLicensing: "Out-licensing",
  consumer: "Consumer Insights",
  hws: "HWS",
  biological: "Biological",
  consumerNeed: "Consumer Need",
};
export const CAPABILITIES_NUMBER = {
  1: "Landscape guided partnership",
  2: "Product Licensing/ Acquisition",
  3: "Partner enabled Manufacturing",
  6: "Solution Scouting",
};

export const MONTHSS = {
  jan: "Jan",
  feb: "Feb",
  mar: "Mar",
  apr: "Apr",
  may: "May",
  jun: "Jun",
  jul: "Jul",
  aug: "Aug",
  sep: "Sep",
  oct: "Oct",
  nov: "Nov",
  dec: "Dec",
};
export const QUARTERS = {
  q1: "Q1",
  q2: "Q2",
  q3: "Q3",
  q4: "Q4",
};
export const NEW_USER_ADDITION_MSGS = {
  1: "It seems you have not assigned any user to add.",
  2: "Please check the manager & actor tab.",
  3: "Please check the manager tab.",
  4: "Please Check the actor tab.",
};
export const ACTIVE_TAB_IDS = {
  1: "selectedPlayers",
  2: "complexityIndex",
  3: "finalizedNeed",
  5: "teamMember",
  7: "selectedPlayers",
  8: "selectedPlayers",
};
export const ACTIVE_TAB = {
  1: Config.SELECTED_PLAYERS_COLLECTION,
  2: Config.COMPLEXITY_PAGELOAD,
  3: Config.FINALIZED_NEED_COLLECTION,
  4: Config.NEED_LICENSE_FEASIBILITY,
  5: Config.TEAM_MEMBERS_COLLECTION,
  6: Config.NOTIFICATIONS_COLLECTION,
  7: Config.SCOUTING_MY_COLLECTION_SAVED_OPPORTUNITIES,
  8: Config.SAVED_STRATEGIC_OPPORTUNITIES_COLLECTION,
};

export const CONTRACT_STATUS = {
  1: "Active",
  2: "Future Update",
  3: "Expired",
  4: "Terminated",
};

export const PROJECT_STATUS = {
  1: "Active",
  2: "Archived",
  3: "Closed",
};

export const CONTRACT_STATUS_IMAGES = {
  1: "/images/active-status.svg",
  2: "/images/active-status.svg",
  3: "/images/active-status.svg",
  4: "/images/complete-status.svg",
};

export const RATIO_TEXT = {
  1: "Killed",
  2: "Optimized",
  3: "Selected",
  4: "Connected",
};

export const INVOICE_STATUS = {
  1: "Generated",
  2: "Sent for approval",
  3: "Approved and docs. uploaded",
  4: "Shared with client and unpaid",
  5: "Partially paid (not in use as of now)",
  6: "Paid",
};

export const USER_ROLES = [
  { label: "Project owner", value: 201 },
  { label: "Project manager", value: 202 },
  { label: "Project view only actor", value: 203 },
  { label: "Project update actor", value: 204 },
];

export const BUSINESS_MODEL_TYPE = {
  1: "Pay per use",
  2: "Shared investment",
};

export const PAYMENT_TYPE = {
  1: "/images/visa-icon.svg",
};

export const ERROR_OCCURED_MSGS = {
  1: "It’s us, not you. Please try after some time.",
  2: "Something went wrong!!",
};

export const VAULT_SCREEN_IDS = {
  LICENSE_FEASIBILITY: 1,
  FORMULATION_ADJACENCY: 2,
  BENEFIT_ADJACENCY: 3,
  COMPLEXITY_ASSESSMENT: 4,
  TRADE_OFF: 5,
  PLAYER_ASSESSMENT: 6,
  PLAYER_PROFILE: 7,
  PRODUCT_PROFILE: 8,
  SAVED_PLAYERS_BUCKET: 9,
  RELEVANCE_INDEX: 10,
  ALL_PRODUCT_INSIGHT: 11,
  ALL_PLAYER_INSIGHT: 12,
  PRODUCT_COMPARATOR: 13,
  STRATEGIC_INSIGHTS: 14,
  TEAM_ASSESSMENT: 15,
  FEASIBILITY_PLAYER_ASSESSMENT: 16,
  LICENSE_FEASIBILITY_PRODUCT_LICENSING: 17,
  FORMULATION_ADJACENCY_PRODUCT_LICENSING: 18,
  BENEFIT_ADJACENCY_PRODUCT_LICENSING: 19,
  FEASIBILITY_PLAYER_ASSESSMENT_PRODUCT_LICENSING: 20,
  MANUFACTURER_LEADS: 21,
  RESEARCH_LEADS: 22,
  SCIENTIFIC_ASSESSMENT: 23,
  IP_MAPPING: 24,
  ECOSYSTEM: 25,
  VALUE_MATRIX: 26,
  INNOVATION_INTENSITY: 27,
  DIFFERENTIATION_POTENTIAL: 28,
  PORTFOLIO_COVERAGE: 29,
  POSITIONING: 30,
  GEOGRAPHICAL: 31,
  REGULATORY: 32,
  FORMAT: 33,
  BENEFITS: 34,
  DEMOGRAPHICS: 35,
  FRESHNESS: 36,
  OPPORTUNITY_COMPARISON_ACTIVE: 38,
  OPPORTUNITY_COMPARISON_FORMAT: 39,
  OPPORTUNITY_COMPARISON_BENEFITS: 40,
  SCOUTING_PLAYER_GRID: 1.1,
  SCOUTING_SAVED_OPPORTUNITIES: 1.2,
  SCOUTING_VALUE_MATRIX: 1.3,
  ECOSYSTEM_LANDSCAPE: 41,
  // ECOSYSTEM: 42,
  STRATEGIC_VALUE_MATRIX: 43,
  STRATEGIC_OPP_PROFILE: 44,
  STRATEGIC_OPP_COMPARATOR: 45,
  STRATEGIC_SAVED_OPPORTUNITIES: 54,
  COMPETITIVE_ECOSYSTEM: 46,
  COMPETITIVE_POSITIOING: 47,
  COMPETITIVE_GEO: 48,
  COMPETITIVE_REGULATORY: 49,
  COMPETITIVE_FORMAT: 50,
  COMPETITIVE_BENEFIT: 51,
  COMPETITIVE_DEMOGRAPHIC: 52,
  COMPETITIVE_INTENSITY: 53,
  COMPETITIVE_EXISTING_ASSETS: 55,
  COMPETITIVE_BRAND_CARRIERS: 56,
  SCOUTING_RELEVANCE: 57,
  COMMERCIAL_ASSESSMENT: 58,
  REGULATORY_ASSESSMENT: 59,
  ADHOC_PLAYER_GRID: 1.4,
  ADHOC_SAVED_OPPORTUNITIES: 1.5,
  ADHOC_VALUE_MATRIX: 1.6,
  ADHOC_RELEVANCE: 60,
  CAPABILITY_VALUE_MATRIX: 61,
  CAPABILITY_OPP_PROFILE: 62,
  CAPABILITY_OPP_COMPARATOR: 63,
  CAPABILITY_SAVED_OPPORTUNITIES: 64,
  OUT_PLAYER_GRID: 65,
  OUT_SAVED_OPPORTUNITIES: 66,
  OUT_VALUE_MATRIX: 67,
  OUT_RELEVANCE: 68,
  CONSUMER_REVIEW_DATA: 69,
  CONSUMER_SOCIAL_DATA: 70,
  CONSUMER_WEB_ANALYTICS: 71,
  CONSUMER_NEED: 72,
  CONSUMER_TRIGGERS: 73,
  CONSUMER_TRENDS: 74,
  CONSUMER_TRIGGERS_SOCIAL: 75,
  CONSUMER_TRENDS_SOCIAL: 76,
  CONSUMER_AGE: 77,
  CONSUMER_GENDER: 78,
  CONSUMER_WORDART: 79,
  CONSUMER_WORDART_SOCIAL: 80,
  SCOUTING_GRAPHS:81
};

export const VAULT_IDS_MODULE3 = {
  17: 1.4,
  5: 65,
};
export const SAVED_PLAYERS = {
  17: 1.5,
  5: 66,
};
export const VALUE_MATRIX_IDS = {
  17: 1.6,
  5: 67,
};
export const RELEVANCE_IDS = {
  17: 60,
  5: 68,
};

export const VAULT_SCREEN_URLS = {
  1: "/innerFameIndex",
  2: "/innerFormulationAdjacency",
  3: "/innerBenefitAdjacency",
  4: "/innerComplexity",
  5: "/innerTradeOff",
  6: "/innerPlayerAssessment",
  7: "/innerPlayerProfile",
  8: "/innerProductProfile",
  9: "/innerSavedPlayerBucket",
  10: "/innerRelevanceIndex",
  ALL_PRODUCT_INSIGHT: 11,
  ALL_PLAYER_INSIGHT: 12,
  13: "/innerProductComparison",
  STRATEGIC_INSIGHTS: 14,
  15: "/innerTeamAssessment",
  16: "/innerFameIndexPlayer",
  17: "/innerFameIndexProductLicensing",
  18: "/innerFormulationAdjacencyProductLicensing",
  19: "/innerBenefitAdjacencyProductLicensing",
  20: "/innerRouteToMarket",
  21: "/innerManufacturerLeads",
  22: "/innerResearchLeads",
  23: "/innerScientificAssessment",
  24: "/innerIpMapping",
  38: "/innerOpportunity",
  39: "/innerOpportunity",
  40: "/innerOpportunity",
  25: "/innerVaultGraph",
  26: "/innerVaultGraph",
  27: "/innerVaultGraph",
  28: "/innerVaultGraph",
  29: "/innerVaultGraph",
  30: "/innerVaultGraph",
  31: "/innerVaultGraph",
  32: "/innerVaultGraph",
  33: "/innerVaultGraph",
  34: "/innerVaultGraph",
  35: "/innerVaultGraph",
  36: "/innerVaultGraph",
  1.1: "/innerScoutingPlayerGrid",
  1.2: "/innerScoutingSavedOpportunities",
  1.3: "/innerScoutingValueMatrix",
  1.4: "/innerScoutingPlayerGrid",
  1.5: "/innerScoutingSavedOpportunities",
  1.6: "/innerScoutingValueMatrix",
  43: "/innerStrategicValueMatrix",
  44: "/innerStrategicOppProfile",
  45: "/innerStrategicOppComparator",
  54: "/innerStrategicSavedOpportunities",
  55: "/innerLandscapeFamiliarity",
  46: "/innerVaultGraphCompetitive",
  47: "/innerVaultGraphCompetitive",
  48: "/innerVaultGraphCompetitive",
  49: "/innerVaultGraphCompetitive",
  50: "/innerVaultGraphCompetitive",
  51: "/innerVaultGraphCompetitive",
  52: "/innerVaultGraphCompetitive",
  53: "/innerVaultGraphCompetitive",
  57: "/innerScoutingRelevance",
  58: "/innerFameIndex",
  59: "/innerRegulatoryInfo",
  61: "/innerStrategicValueMatrix",
  62: "/innerStrategicOppProfile",
  63: "/innerStrategicOppComparator",
  64: "/innerStrategicSavedOpportunities",
  65: "/innerScoutingPlayerGrid",
  66: "/innerScoutingSavedOpportunities",
  67: "/innerScoutingValueMatrix",
  68: "/innerScoutingRelevance",
  69: "/innerConsumerReview",
  70: "/innerConsumerSocial",
  71: "/innerConsumerWebAnalytics",
  72: "/innerConsumerGraph",
  73: "/innerConsumerGraph",
  74: "/innerConsumerGraph",
  75: "/innerConsumerGraph",
  76: "/innerConsumerGraph",
  77: "/innerConsumerGraph",
  78: "/innerConsumerGraph",
  79: "/innerConsumerGraph",
  80: "/innerConsumerGraph",
  81:"/innerScoutingGraphs"
};

export const conflict = {
  "-116007": "Conflict Type- Tree Entry",
  "-116006": "Conflict Type- Same Entry",
  "-116008": "Conflict Type- Invalid Desirable",
};

export const conflictClasses = {
  ES: "toast a2 fade show w-cross footer-widget",
  DE: "toast a1 fade show w-cross footer-widget",
};

export const conflictHeads = {
  DE: "[Desirable & Exclusion]",
  ES: "[Essential & Exclusion]",
};

export const CATEGORY_EXIST = -116004;
export const CATEGORY_NOT_EXIST = -116005;
export const CATEGORY_MISS_MATCH = -116009;
export const CATEGORY_MISSING = -116004;
export const NO_CATEGORY_AND_BENEFITS_AND_BRANDCARRIERS = -116005;

//validation page
export const STRUCTURAL_CHANGE = -116016;
export const DUPLICATE = -116010;
export const MARKET_MISS_MATCH = -116014;
export const CATEGORY_REFINEMENT = -116012;
export const LOW_CORRELATION_WITH_OTHERS = -116013;
export const ACTIVE_AND_FORMAT_MISSING = -116001;
export const BENEFIT_AND_CLAIM_MISSING = -116002;
export const REGULATIONS_AND_USERSEGMENT_AND_PACKAGETYPE_MISSING = -116003;
export const AVAILABILITY_MISSING = -116011;
export const MISSING_MARKET_CHECK = -116015;
export const CLAIM_MISSING = -116017;
export const WRONG_MAPPED_REGULATORY = -116018;

//idle time, infinite scroll items
export const NUMBER_OF_ITEMS = 10;
export const IDLE_TIME = 3000000;
export const startSave = 120;
export const BLINK_NAVIGATION = 30000;

//cost center
export const COSTCENTER_NEW_USER_CREATION_CONSENT_REQUIRED = -106009;
export const NO_COSTCENTER_HEAD_ROLE = -106010;

//invalid credentials
export const INVALID_OTP = -101012;
export const INVALID_PASSWORD = -101004;

export const PROJECT_SUB_STAGE = {
  1: 1.3,
  2: 1.3,
  3: 1.3,
  5: 1.9,
  6: 1.9,
  7: 1.5,
  8: 1.11,
  9: 1.11,
  10: 1.11,
  11: 1.11,
  14: 1.5,
  18: 1.11,
  19: 1.9,
  20: 1.9,
  21: 1.9,
  22: 1.9,
};

export const pptCapability = {
  //capability names or ppt
  1: "Landscape guided partnership",
  2: "Product Licensing/ Acquisition",
  3: "Need Assessment",
};

export const ROUTE_TO_MARKET = [
  {
    routeName: "Monograph",
    routeValue: "monograph",
  },
  {
    routeName: "Registration",
    routeValue: "registration",
  },
];

export const PLAYER_TYPE = {
  0: "Probable license holder/ distributor",
  1: "Retailer",
  2: "License holder/ marketer | manufacturer",
  3: "Manufacturer",
  4: "License holder/ marketer",
  5: "Third party distributor/ trading firm",
  6: "License holder/ marketer and manufacturer",
  7: "Probable License holder/ marketer and manufacturer",
  8: "License holder/ marketer",
};

export const ordinal = {
  //ordinals for dose
  1: "first",
  2: "second",
  3: "third",
  4: "fourth",
  5: "fifth",
  6: "sixth",
  7: "seventh",
  8: "eighth",
  9: "ninth",
  10: "tenth",
};

export const selectionsMade = {
  //no selection
  1: "None of the options available in Essentials is selected. Please make selection if you want to input Any value in any particular head.",
  2: "None of the options available in Preferences is selected. Please make selection if you want to input Any value in any particular head.",
  3: "None of the options available in Exclusions is selected. Please make selection if you want to input Any value in any particular head.",
};

export const mainHead = ["Essentials", "Preferences", "Exclusions"];

export const missingComponent = {
  0: "No selection under Active and Format head inside Essential.",
  1: "No selection under Health Benefits head inside Essential.",
  2: "No selection made in Regulations, User Segment and Package Type.",
  3: "No selection under Category head inside Essential.",
};

//missing components
export const missingComponents = [
  {},
  {
    fields: [
      {
        mainHead: "essentials",
        category: "positioning",
        value: "Benefits",
        displayContent: "Health Benefits",
        index: 6,
        tip: 36,
      },
    ],
  },
  {
    fields: [
      {
        mainHead: "essentials",
        category: "formulation",
        value: "Active",
        displayContent: "Active",
        index: 0,
        tip: 35,
      },
      {
        mainHead: "essentials",
        category: "formulation",
        value: "Dosage",
        displayContent: "Dosage",
        index: 1,
        tip: 35,
      },
    ],
  },
  {
    fields: [
      {
        mainHead: "essentials",
        category: "formulation",
        value: "Package type",
        displayContent: "Package Type",
        index: 5,
        tip: 37,
      },
      {
        mainHead: "essentials",
        category: "positioning",
        value: "User segment",
        displayContent: "Demographics",
        index: 8,
        tip: 37,
      },
      {
        mainHead: "essentials",
        category: "others",
        value: "Regulatory class",
        displayContent: "Regulatory Class",
        index: 9,
        tip: 37,
      },
    ],
  },
  {
    fields: [
      {
        mainHead: "essentials",
        category: "positioning",
        value: "Category",
        displayContent: "Category",
        index: 10,
        tip: 49,
      },
    ],
  },
  {
    fields: [
      {
        mainHead: "preferences",
        category: "others",
        value: "Availability",
        displayContent: "Availability",
        tip: 38,
      },
    ],
  },
  {
    fields: [
      {
        mainHead: "essentials",
        category: "market",
        value: "Lead Markets",
        displayContent: "Lead Markets",
        index: 0,
        tip: 35,
      },
      {
        mainHead: "essentials",
        category: "market",
        value: "Other Markets",
        displayContent: "Other Markets",
        index: 1,
        tip: 35,
      },
    ],
  },
  {
    fields: [
      {
        mainHead: "essentials",
        category: "positioning",
        value: "Claims",
        displayContent: "Functional benefit",
        index: 6,
        tip: 36,
      },
    ],
  },
];

export const registrationYearData = {
  category: "others",
  subCategory: "registrationYear",
  displayContent: "Registration Year",
  treeHead: "Registration year",
};

export const availabilityData = {
  category: "others",
  subCategory: "availability",
  displayContent: "Availability",
  treeHead: "Availability",
};

export const dataForHeads = [
  {
    category: "others",
    subCategory: "playerName",
    headName: "Player name",
    displayContent: "Player name",
    treeHead: "Player name",
    uniqueListValue: "playerName",
    keywordRequired: false,
  },
  {
    category: "positioning",
    subCategory: "claims",
    headName: "Functional benefit",
    displayContent: "Functional benefit",
    treeHead: "Claims",
    uniqueListValue: "claimUniqueValue",
    uniqueListType: "claimUniqueValueType",
    keywordRequired: true,
    treeExist: true,
  },
  {
    category: "formulation",
    subCategory: "flavor",
    headName: "Flavor",
    displayContent: "Flavor",
    treeHead: "Flavor",
    uniqueListValue: "flavorUniqueValue",
    uniqueListType: "flavorUniqueValueType",
    keywordRequired: true,
    treeExist: true,
  },
  {
    category: "others",
    subCategory: "sanitizedIndication",
    headName: "Indication",
    displayContent: "Indication",
    treeHead: "Sanitized indication",
    uniqueListValue: "sanitizedIndicationValue",
    keywordRequired: false,
  },
  {
    category: "formulation",
    subCategory: "inactiveIngredients",
    headName: "Inactive ingredient",
    displayContent: "Inactive ingredients",
    treeHead: "Inactive ingredients",
    uniqueListValue: "inactiveIngredientsValue",
    uniqueListType: "inactiveIngredientsValueType",
    keywordRequired: true,
  },
  {
    category: "formulation",
    subCategory: "packageType",
    headName: "Package types",
    displayContent: "Package type",
    treeHead: "Package type",
    uniqueListValue: "packagingUniqueValue",
    uniqueListType: "packagingUniqueValueType",
    keywordRequired: true,
  },
  {
    category: "others",
    subCategory: "regulatoryClass",
    headName: "Regulatory classes",
    displayContent: "Regulatory class",
    treeHead: "Regulatory class",
    uniqueListValue: "regulationUniqueValue",
    uniqueListType: "regulationUniqueValueType",
    keywordRequired: true,
  },
  {
    category: "market",
    subCategory: "leadMarkets",
    headName: "Lead markets",
    displayContent: "Lead markets",
    treeHead: "Markets",
    uniqueListValue: "marketUniqueValue",
    uniqueListType: "marketUniqueValueType",
    keywordRequired: true,
  },
  {
    category: "market",
    subCategory: "markets",
    headName: "Markets",
    displayContent: "Markets",
    treeHead: "Markets",
    uniqueListValue: "marketUniqueValue",
    uniqueListType: "marketUniqueValueType",
    keywordRequired: true,
  },
  {
    category: "positioning",
    subCategory: "category",
    headName: "Category",
    displayContent: "Category",
    treeHead: "Category",
    uniqueListValue: "categoryUniqueValue",
    uniqueListType: "categoryUniqueValueType",
    keywordRequired: true,
  },
  {
    category: "market",
    subCategory: "otherMarkets",
    headName: "Other markets",
    displayContent: "Other markets",
    treeHead: "Markets",
    uniqueListValue: "marketUniqueValue",
    uniqueListType: "marketUniqueValueType",
    keywordRequired: true,
  },
  {
    category: "formulation",
    subCategory: "active",
    headName: "Active",
    displayContent: "Active",
    treeHead: "Active",
    uniqueListValue: "activeUniqueValue",
    uniqueListType: "activeUniqueValueType",
    keywordRequired: true,
  },
  {
    category: "formulation",
    subCategory: "format",
    headName: "Format",
    displayContent: "Format",
    treeHead: "Format",
    uniqueListValue: "formatUniqueValue",
    uniqueListType: "formatUniqueValueType",
    keywordRequired: true,
  },
  {
    category: "formulation",
    subCategory: "sanitizedRouteOfAdministration",
    headName: "Sanitized route of administration",
    displayContent: "Route of administration",
    treeHead: "Sanitized route of administration",
    uniqueListValue: "sanitizedRouteOfAdministrationValue",
    uniqueListType: "sanitizedRouteOfAdministrationValueType",
    keywordRequired: true,
  },
  {
    category: "positioning",
    subCategory: "userSegment",
    headName: "User segment",
    displayContent: "Demographics",
    treeHead: "User segment",
    uniqueListValue: "userSegmentUniqueValue",
    uniqueListType: "userSegmentUniqueValueType",
    keywordRequired: true,
  },
  {
    category: "positioning",
    subCategory: "benefits",
    headName: "Benefits",
    displayContent: "Health benefits",
    treeHead: "Benefits",
    uniqueListValue: "benefitUniqueValue",
    uniqueListType: "benefitUniqueValueType",
    keywordRequired: true,
  },
  {
    category: "others",
    subCategory: "countryOfOrigin",
    headName: "Country of origin",
    displayContent: "Country of origin",
    treeHead: "Country of origin",
    uniqueListValue: "countryUniqueValue",
    uniqueListType: "countryUniqueValueType",
    keywordRequired: true,
  },
  {
    category: "market",
    subCategory: "leadMarkets",
    headName: "Lead markets",
    displayContent: "Lead markets",
    treeHead: "Markets",
    uniqueListValue: "marketUniqueValue",
    uniqueListType: "marketUniqueValueType",
    keywordRequired: true,
  },
  {
    category: "formulation",
    subCategory: "active1",
    headName: "Active",
    displayContent: "Active",
    treeHead: "Active",
    uniqueListValue: "activeUniqueValue",
    uniqueListType: "activeUniqueValueType",
    keywordRequired: true,
  },
  {
    category: "formulation",
    subCategory: "active2",
    headName: "Active",
    displayContent: "Active Double Combination",
    treeHead: "Active",
    uniqueListValue: "activeUniqueValue",
    uniqueListType: "activeUniqueValueType",
    keywordRequired: true,
  },
  {
    category: "formulation",
    subCategory: "active3",
    headName: "Active",
    displayContent: "Active Triple/More Combination",
    treeHead: "Active",
    uniqueListValue: "activeUniqueValue",
    uniqueListType: "activeUniqueValueType",
    keywordRequired: true,
  },
  {
    category: "formulation",
    subCategory: "markets",
    headName: "Markets",
    displayContent: "Markets",
    treeHead: "Markets",
    uniqueListValue: "marketUniqueValue",
    uniqueListType: "marketUniqueValueType",
    keywordRequired: true,
  },
];

export const displayCategory = {
  0: "others",
  1: "formulation",
  2: "positioning",
  3: "market",
};

export const displayCategoryName = {
  0: "Others",
  1: "Formulation",
  2: "Positioning",
  3: "Market",
};

export const uniqueLists = {
  Active: 0,
  Format: 1,
  Markets: 2,
  Flavor: 3,
  Benefits: 6,
  Claims: 7,
  "User segment": 8,
  "Package type": 5,
  "Regulatory class": 9,
  Category: 10,
  "Sanitized route of administration": 4,
  "Inactive ingredients": 11,
  "Sanitized indication": 12,
  "Player name": 13,
  "Registration year": 14,
  Availability: 15,
};

export const dbKeys = {
  0: "active",
  1: "format",
  2: "benefits",
  3: "claims",
  4: "userSegment",
  5: "flavor",
  6: "packageType",
  7: "regulatoryClass",
  8: "category",
  9: "sanitizedRouteOfAdministration",
  10: "markets",
  11: "inactiveIngredients",
  12: "sanitizedIndication",
  13: "playerName",
  14: "registrationYear",
  15: "availability",
  16: "leadMarkets",
};

export const categoryDb = {
  0: "formulation",
  1: "formulation",
  6: "formulation",
  9: "formulation",
  5: "formulation",
  11: "formulation",
  2: "positioning",
  4: "positioning",
  8: "positioning",
  3: "positioning",
  10: "market",
  7: "others",
  12: "others",
  13: "others",
  14: "others",
  15: "others",
};

export const STAGE_NAME = {
  //db stages are diff & UI stages are combined. keys denoted db stage & val denote its data
  1: {
    style: { backgroundColor: "#005e20" },
    display: "Need Defining",
    icon: "defining",
    stage: 1,
    iconShow: "far fa-file-alt",
  },
  2: { display: "Need Defining", icon: "defining", stage: 1 },
  3: {
    style: { backgroundColor: "#f26522" },
    display: "Feasibility/Health Check",
    icon: "feasability",
    stage: 3,
    iconShow: "fas fa-balance-scale",
  },
  4: {
    display: "Feasibility/Health Check",
    icon: "feasability",
    stage: 3,
  },
  5: {
    display: "Feasibility/Health Check",
    icon: "feasability",
    stage: 3,
  },
  6: {
    display: "Feasibility/Health Check",
    icon: "feasability",
    stage: 3,
  },
  7: {
    display: "Feasibility/Health Check",
    icon: "feasability",
    stage: 3,
  },
  8: {
    style: { backgroundColor: "#00aeef" },
    display: "Player Assessment",
    icon: "playermap",
    stage: 8,
    iconShow: "fa fa-binoculars",
  },
  9: {
    style: { backgroundColor: "#005952" },
    display: "Player Connect",
    icon: "establish",
    stage: 9,
    iconShow: "fa fa-link",
  },
  10: {
    style: { backgroundColor: "#8560a8" },
    display: "Player Engagement",
    icon: "playerevol",
    stage: 10,
    iconShow: "fas fa-users",
  },
  11: {
    style: { backgroundColor: "#8dc63f" },
    display: "Deal",
    icon: "partnership",
    stage: 11,
    iconShow: "fa fa-handshake-o",
  },
  12: {
    style: { backgroundColor: "#000000" },
    display: "Closed/ Archive",
    icon: "archive",
    stage: 12,
    iconShow: "fa fa-archive",
  },
};

export const PROJECT_STAGE = {
  //db project stages
  NEED_DEFINING: 1,
  NEED_PROCESSING_STAGE_1: 2,
  LICENSE_FEASIBILITY: 3,
  NEED_OPTIMIZATION: 4,
  TRADEOFF_SELECTIONS: 5,
  NEED_PROCESSING_STAGE_2: 6,
  BREAKER_MODULE: 7,
  PLAYER_MAPPING: 8,
  PLAYER_CONNECT: 9,
  PLAYER_ENGAGEMENT: 10,
  DEAL: 11,
  CLOSED: 12,
};

export const vault = {
  LICENSE_FEASIBILITY: 1,
  FORMULATION_ADJACENCY: 2,
  BENEFIT_ADJACENCY: 3,
  COMPLEXITY_ASSESSMENT: 4,
  TRADE_OFF: 5,
  PLAYER_ASSESSMENT: 6,
  PLAYER_PROFILE: 7,
  PRODUCT_PROFILE: 8,
  SAVED_PLAYERS_BUCKET: 9,
  RELEVANCE_INDEX: 10,
  ALL_PRODUCT_INSIGHT: 11,
  ALL_PLAYER_INSIGHT: 12,
  PRODUCT_COMPARATOR: 13,
  STRATEGIC_INSIGHTS: 14,
  TEAM_ASSESSMENT: 15,
  FEASIBILITY_PLAYER_ASSESSMENT: 16,
};

export const SUB_STAGE_NOTIFICATION = {
  NEED_DEFINING: 1.5,
  LICENSE_FEASIBILITY_SUB_STAGE_NAME: 3.1,
  LICENSE_FEASIBILITY_SUB_STAGE_NAME_1: 3.2,
  NEED_OPTIMIZATION_SUB_STAGE: 4.1,
  PLAYER_MAPPING: 8.1,
  PLAYER_MAPPING_1: 8.2,
  PROJECT_DETAIL: 9.1,
  CONSUMER_NEEDS: 8.2,
};

export const SUB_STAGE = {
  HOME_PAGE: 1.0,
  CREATE_PROJECT: 0.1,
  EDIT_PROJECT: 1.1,
  READ_PROJECT: 1.2,
  TEMPLATE_UPLOAD: 1.3,
  QUERY_HEAD_DEFINING: 1.4,
  QUERY_INPUT: 1.5,
  QUERY_VALIDATION: 1.6,
  TEMPLATE_PROCESSING: 1.7,
  TEMPLATE_PROCESSING_QUERY_VALIDATION: 1.8,
  SCOUTING_INPUT: 1.9,
  STRATEGIC_INPUT: 1.11,
  NEED_PROCESSING_SUB_STAGE_1: 2.1,
  HALTED_STAGE: 2.2,
  NEED_PROCESSING_SUB_STAGE_3: 2.3,
  LICENSE_FEASIBILITY: 3.1,
  LICENSE_FEASIBILITY_PRODUCT_LICENSING: 3.2,
  NEED_OPTIMIZATION: 4.1,
  TRADEOFF_SELECTIONS: 5.1,
  NEED_PROCESSING_SUB_STAGE_2: 6.1,
  NEED_PROCESSING_SUB_STAGE_5: 6.5,
  BREAKER_MODULE: 7.1,
  PLAYER_MAPPING: 8.1,
  SCOUTING_PLAYER_MAPPING: 8.2,
  CLOSED_SUB_STAGE: 12.1,
};

export const COMMON_URLS_FOR_CAPABILITIES = {
  1.0: "/userDashboard",
  0.1: "/createProject",
  1.1: "/editProject",
  1.3: "/uploadTemplate",
  9.1: "/projectDetail",
};

export const REDIRECT_URLS_NAMES = {
  1: {
    1.0: "/userDashboard",
    0.1: "/createProject",
    1.1: "/editProject",
    1.3: "/uploadTemplate",
    1.4: "/queryHeadDefining",
    1.5: "/queryInput",
    1.6: "/queryValidation",
    2.1: "/needProcessingStage1",
    3.1: "/licenseFeasibility",
    3.2: "/productLicensing",
    4.1: "/needOptimization",
    5.1: "/tradeOff",
    6.1: "",
    7.1: "/breakModule2-3",
    8.1: "/pocMain",
    9.1: "/projectDetail",
  },
  5: {
    1.0: "/userDashboard",
    0.1: "/createProject",
    1.1: "/editProject",
    1.9: "/queryBuilderScouting",
    2.1: "/needProcessingStage1",
    6.1: "",
    7.1: "/breakModule2-3",
    8.2: "/scoutingModule3",
    9.1: "/projectDetail",
  },
  6: {
    1.0: "/userDashboard",
    0.1: "/createProject",
    1.1: "/editProject",
    1.9: "/queryBuilderScouting",
    2.1: "/needProcessingStage1",
    6.1: "",
    7.1: "/breakModule2-3",
    8.2: "/scoutingModule3",
    9.1: "/projectDetail",
  },
  7: {
    1.0: "/userDashboard",
    0.1: "/createProject",
    1.1: "/editProject",
    1.3: "/uploadTemplate",
    2.1: "/needProcessingStage1",
    6.1: "",
    7.1: "/breakModule2-3",
    8.1: "/landscapeModule3Home",
    9.1: "/projectDetail",
    1.5: "/queryBuilderLandscape",
  },
  14: {
    1.0: "/userDashboard",
    0.1: "/createProject",
    1.1: "/editProject",
    1.5: "/queryInput",
    1.6: "/queryValidation",
    2.1: "/needProcessingStage1",
    3.1: "/licenseFeasibility",
    4.1: "/needOptimization",
    6.1: "",
    7.1: "/breakModule2-3",
    9.1: "/projectDetail",
  },
  8: {
    1.0: "/userDashboard",
    0.1: "/createProject",
    1.1: "/editProject",
    1.9: "/queryBuilderScouting",
    2.1: "/needProcessingStage1",
    6.1: "",
    7.1: "/breakModule2-3",
    8.2: "/strategicModule3Home",
    9.1: "/projectDetail",
    1.11: "/startegicQueryInput",
  },
  17: {
    1.0: "/userDashboard",
    0.1: "/createProject",
    1.1: "/editProject",
    1.9: "/adhocInputScreen",
    2.1: "/needProcessingStage1",
    6.1: "",
    7.1: "/breakModule2-3",
    8.2: "/scoutingModule3",
    9.1: "/projectDetail",
  },
  19: {
    1.0: "/userDashboard",
    0.1: "/createProject",
    1.1: "/editProject",
    1.9: "/consumerQueryBuilder",
    2.1: "/needProcessingStage1",
    6.1: "",
    7.1: "/breakModule2-3",
    8.2: "/consumerModule3",
    9.1: "/projectDetail",
  },
  20: {
    1.0: "/userDashboard",
    0.1: "/createProject",
    1.1: "/editProject",
    1.9: "/hwsQueryBuilder",
    2.1: "/needProcessingStage1",
    6.1: "",
    7.1: "/breakModule2-3",
    8.1: "/hwsOutcome",
    8.2: "/hwsModule3",
    9.1: "/projectDetail",
  },
  21: {
    1.0: "/userDashboard",
    0.1: "/createProject",
    1.1: "/editProject",
    1.9: "/biologicalQueryBuilder",
    2.1: "/needProcessingStage1",
    6.1: "",
    7.1: "/breakModule2-3",
    8.1: "/biologicalOutcome",
    8.2: "/biologicalModule3",
    9.1: "/projectDetail",
  },
  22: {
    1.0: "/userDashboard",
    0.1: "/createProject",
    1.1: "/editProject",
    1.9: "/consumerQueryBuilder",
    2.1: "/needProcessingStage1",
    6.1: "",
    7.1: "/breakModule2-3",
    8.1: "/consumerOutcome",
    8.2: "/consumerModule3",
    9.1: "/projectDetail",
  },
};

export const REDIRECT_URLS = {
  1.0: "/userDashboard",
  0.1: "/createProject",
  1.1: "/editProject",
  1.3: "/uploadTemplate",
  1.4: "/queryHeadDefining",
  1.5: "/queryInput",
  1.6: "/queryValidation",
  1.9: "/queryBuilderScouting",
  2.1: "/needProcessingStage1",
  3.1: "/licenseFeasibility",
  3.2: "/productLicensing",
  4.1: "/needOptimization",
  5.1: "/tradeOff",
  6.1: "",
  7.1: "/breakModule2-3",
  8.1: "/pocMain",
  8.2: "/scoutingModule3",
  8.3: "/landscapeModule3Home",
  8.4: "/strategicModule3Home",
  9.1: "/projectDetail",
  1.11: "/startegicQueryInput",
  1.12: "/queryBuilderLandscape",
};

export const NAVIGATION_SCREEN_NUMBER = {
  CAPABILITY_HOME_SCREEN: 0.1,
  PROJECT_NOMENCLATURE: 1.1,
  SHARE_NEED: 1.2,
  QUERY_HEAD_DEFINING: 1.3,
  QUERY_INPUT: 1.4,
  ACTIVE_SCREEN: 1.5,
  LICENSE_FEASIBILITY: 2.1,
  ADJACENCIES: 2.2,
  COMPLEXITY: 2.3,
  TRADE_OFF: 2.4,
  ADJACENCIES_PRODUCT_LICENSING: 2.5,
  PLAYER_GRID: 3.1,
  RELEVANCE_INDEX: 3.2,
  PRODUCT_COMPARISON: 3.3,
  OPPORTUNITY_DATA: 3.4,
  SCOUTING_SAVED_OPP: 3.8,
  STRATEGIC_SAVED_OPP: 3.9,
  CONTRACT_MIS: 4.1,
  MANAGEMENT_SUMMARY: 4.2,
  PROJECT_DETAILS: 4.3,
  VAULT: 4.4,
  TEAM_ASSESSMENT: 4.5,
  INSIGHTS: 5.1,
};

export const MODULE_NUMBER = {
  CAPABILITY_SCREEN: 0,
  STAGE_NUMBER1: 1,
  STAGE_NUMBER2: 2,
  STAGE_NUMBER3: 3,
  STAGE_NUMBER4: 4,
  STAGE_NUMBER5: 5,
};

export const WEEKDAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const COMPLEXITY_HEADS = {
  1: "Regulatory",
  1.1: "Regulatory",
  1.2: "Regulatory",
  2: "Format",
  3: "Active",
  4: "UserSegment/Demographic",
  5: "Product Type",
  6: "Competition",
  7: "Growth Potential",
};

export const ADVANCED_FILTERS = [
  {
    keyword: "AD1",
    tag: "Desired Opportunities",
    tag1: "Desired Opportunities",
  },
  { keyword: "AD2", tag: "Lead Market Access", tag1: "Lead Market Access" },
  { keyword: "AD3", tag: "Recent Dossier", tag1: "Recent launches" },
  {
    keyword: "AD4",
    tag: "Expectation Match Opportunities",
    tag1: "Expectation Match Opportunities",
  },
];

export const preferenceHeads = [
  {
    display: "Player name",
    dbKey: "playerName",
  },
  {
    display: "Functional benefit",
    dbKey: "claims",
  },
  {
    display: "Flavor",
    dbKey: "flavor",
  },
  {
    display: "Indication",
    dbKey: "sanitizedIndication",
  },
  {
    display: "Inactive ingredients",
    dbKey: "inactiveIngredients",
  },
  {
    display: "Active",
    dbKey: "active",
  },
  {
    display: "Format",
    dbKey: "format",
  },
  {
    display: "Demographics",
    dbKey: "userSegment",
  },
  {
    display: "Route of Administration",
    dbKey: "sanitizedRouteOfAdministration",
  },
  {
    display: "Health Benefits",
    dbKey: "benefits",
  },
  {
    display: "Regulatory Class",
    dbKey: "regulatoryClass",
  },
  {
    display: "Package Type",
    dbKey: "packageType",
  },
  {
    display: "Intervention",
    dbKey: "intervention",
  },
  {
    display: "Markets",
    dbKey: "markets",
  },
  {
    display: "Category",
    dbKey: "category",
  },
  {
    display: "Inactive Tags",
    dbKey: "inactiveTags",
  },
  {
    display: "Registration Year",
    dbKey: "registrationYear",
  },
  {
    display: "Country of origin",
    dbKey: "countryOfOrigin",
  },
];
